import { render, staticRenderFns } from "./ProductModule.vue?vue&type=template&id=4433ddee&"
import script from "./ProductModule.vue?vue&type=script&lang=js&"
export * from "./ProductModule.vue?vue&type=script&lang=js&"
import style0 from "./ProductModule.vue?vue&type=style&index=0&id=4433ddee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports